"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/styles");
var useStyles = (0, styles_1.makeStyles)(function (t) { return (0, styles_1.createStyles)({
    menu_head: {
        marginTop: -t.spacing(1),
        borderBottom: "1px solid " + t.palette.divider,
        display: 'flex',
        alignItems: 'center',
        minHeight: 48,
    },
    menu_headWithCb: {
        paddingLeft: 0,
    },
    menu_input: {
        background: 'none',
        border: 'none',
        width: '100%',
        height: 30,
        fontSize: '1rem',
        color: t.palette.text.primary,
    },
    menu_items: {
        maxHeight: 300,
        overflowY: 'auto',
        minWidth: 220,
    },
    adornment: {
        height: 20,
        color: t.palette.text.secondary,
        verticalAlign: 'top',
    }
}); });
var Autocomplete = function (_a) {
    var value = _a.value, multiple = _a.multiple, searchLabel = _a.searchLabel, readonly = _a.readonly, children = _a.children, onChange = _a.onChange;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var _c = React.useState(undefined), filter = _c[0], setFilter = _c[1];
    var $input = undefined;
    var classes = useStyles();
    var open = function (event) { return setAnchorEl(event.currentTarget); };
    var close = function () {
        setAnchorEl(null);
        setFilter('');
    };
    var handleChange = function (changedValue) {
        var getValue = function () {
            if (multiple) {
                return ((value === null || value === void 0 ? void 0 : value.indexOf(changedValue)) === -1) ? value.concat(changedValue) : value.filter(function (_) { return _ !== changedValue; });
            }
            else {
                close();
                return value !== changedValue ? changedValue : '';
            }
        };
        onChange(getValue());
    };
    var getFilteredChildren = function () {
        if (!children)
            return [];
        var items = React.Children.map(children, function (_) { return _; });
        return (filter && filter !== '')
            ? items.filter(function (_) { return _.props.value.toLowerCase().indexOf(filter.toLowerCase()) !== -1; })
            : items;
    };
    var selectAll = function (event, checked) {
        if (children) {
            var values = checked ? React.Children.map(children, function (_) { return _.props.value; }) : [];
            onChange(values);
        }
    };
    var optionsCount = React.Children.count(children);
    var filteredChildren = getFilteredChildren();
    return (React.createElement(React.Fragment, null,
        React.createElement(material_1.Input, { onClick: open, value: multiple ? value && value.join(', ') : value, disabled: readonly, inputRef: function (n) { return $input = n !== null && n !== void 0 ? n : undefined; }, endAdornment: React.createElement(material_1.InputAdornment, { position: "end" },
                React.createElement(material_1.Icon, { className: classes.adornment }, "arrow_drop_down")) }),
        React.createElement(material_1.Menu, { anchorEl: anchorEl, open: !!anchorEl, onClose: close },
            React.createElement("header", { className: (0, classnames_1.default)(classes.menu_head, multiple && classes.menu_headWithCb) },
                multiple &&
                    React.createElement(material_1.Checkbox, { checked: !!value && value.length === optionsCount, onChange: selectAll, indeterminate: !!value && (value.length > 0 && value.length < optionsCount), disabled: readonly }),
                React.createElement("input", { autoFocus: true, className: classes.menu_input, placeholder: searchLabel, style: !multiple ? { marginLeft: 12 } : {}, onChange: function (e) { return setFilter(e.target.value); } })),
            React.createElement("div", { className: classes.menu_items, style: { width: $input === null || $input === void 0 ? void 0 : $input.clientWidth } }, filteredChildren.map(function (_) {
                return React.cloneElement(_, __assign(__assign({}, _.props), { multiple: multiple, checked: !!value && value.indexOf(_.props.value) !== -1, onClick: handleChange }));
            })))));
};
exports.Autocomplete = Autocomplete;
//# sourceMappingURL=Autocomplete.js.map